import styled from "styled-components";

import { pageStyle } from "../styles/pageStyles";

const StyledPage = styled.div`
    ${pageStyle};
`;

const StyledHeader = styled.div`
    ${pageStyle};
`;

const StyledTitle = styled.div`
    ${pageStyle};
`;

const StyledContent = styled.div`
    ${pageStyle};
`;

export const FPage = styled(StyledPage).attrs(() => ({ className: "aevi-page-container" as string }))``;

export const FPageHeader = styled(StyledHeader).attrs(() => ({ className: "aevi-page-header" as string }))``;

export const FPageTitle = styled(StyledTitle).attrs(() => ({ className: "aevi-page-title" as string }))``;

export const FPageContent = styled(StyledContent).attrs(() => ({ className: "aevi-page-content" as string }))``;
